export default __webpack_public_path__ + "static/media/fees.fe2b9dc3.svg";